import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

interface TemplateProps {
  pageId: number
}
const categoryTitle = '公共/行政'
const baseUrl = '/cases/public/'

const Template: React.FC<TemplateProps> = ({ pageId }) => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={pageId} />
}

export default Template
